import SummaryView from "./SummaryView";
import CalendarView from "./CalendarView";
import LogView from "./LogView";
import TableView from "./TableView";
import ReportsView from "./ReportsView";

// Single source of truth for the Progress views. Order = display order. Each
// entry maps a tab to its component so both the ViewSwitch (id + label +
// icon) and the renderer (Component) derive from one list — adding a view is
// a one-line change here.
export const PROGRESS_VIEWS = [
  { id: "summary",  icon: "/img/new-icons/paste.svg",                  Component: SummaryView },
  { id: "calendar", icon: "/img/new-icons/vuesax-linear-calendar.svg", Component: CalendarView },
  { id: "log",      icon: "/img/new-icons/file-document.svg",           Component: LogView },
  { id: "table",    icon: "/img/new-icons/table-view.svg",              Component: TableView },
  { id: "reports",  icon: "/img/new-icons/stats-chart.svg",            Component: ReportsView },
];

export const DEFAULT_PROGRESS_VIEW = PROGRESS_VIEWS[0].id;

// The component for a view id (falls back to the default view's component).
export const viewComponentFor = (id) =>
  (PROGRESS_VIEWS.find((v) => v.id === id) || PROGRESS_VIEWS[0]).Component;
